/**
 * Boolean filter values
 */
export enum BooleanFilterEnum {
	EXCLUDE = 'exclude',
	INCLUDE = 'include',
	ONLY = 'only',
}
